import { GetVehicleTrackerDocument } from '@/api/queries';
import SelectFromQuery from '../SelectFromQuery';

const SelectVehicleTracker = (props) => (
  <SelectFromQuery
    cache="VehicleTracker"
    placeholder="All Exchange Locations"
    query={GetVehicleTrackerDocument}
    selector={(data) => {
      return (data?.getFilters?.filters?.vehicleTracker || []).map((opt) => ({
        label: opt.displayName,
        value: opt.id,
      }));
    }}
    {...props}
  />
);

export default SelectVehicleTracker;
